namespace('compass.tiles');

compass.requireLib('compass.util.format');

compass.tiles.GroupContactTileWidget = compass.defineWidget(function GroupContactTileWidget (options) {
	var me = this;
	var d = jQuery.dom.getContext(me);
	var _settings = options;

	var _labels = {
		title: 'Group Manager',
		email: 'Email: ',
		phone: 'Phone: '
	};

	var _cleanPhone = function (raw) {
		var clean = "";
		for (var i = 0, l = raw.length; i < l; i++) {
			if (raw[i] >= '0' && raw[i] <= '9') {
				clean += raw[i];
			}
		}
		return clean;
	};

	var _render = me.render = function (widgetElem) {
		var contact = _settings.groupContact;
		contact.name = contact.firstName + ' ' + contact.lastName;

		widgetElem.append(d.div({
			className: 'tile smallTile'
		}, d.div({
				className: 'title smallTileHeader'
			}, 
				d.h3({ className : 'headerCopy' }, _labels.title)
			),
			d.div({
				className: 'smallTileCopy'
			},
				d.div({
					className: 'contactName'
				}, contact.name),
				d.div({
					className: 'contactEmail'
				}, d.a({
						href: 'mailto:' + contact.email
					}, contact.email)),
				d.div({
					className: 'contactPhone'
				}, d.span({
						//href: 'tel:' + _cleanPhone(contact.phone)
					}, _formatNumber(contact.phone)))
			)
		));
	};

	var _formatNumber = compass.util.phoneFormatter({}) || {};
}, {
	WUID: 'CRAP',
	widgetName: 'GroupContactTileWidget',
	groupContact: {
		firstName: 'Group',
		lastName: 'Contact',
		email: 'manager@your.group',
		phone: '111-2233'
	}
});
